module.exports = __webpack_public_path__ + "img/bg_tech2.8015cf33.jpg";